<template>
  <div style="width:54px">
    <v-select
      v-model="language"
      :items="$i18n.availableLocales"
      hide-details="auto"
    >
      <template v-slot:item="{ item }">{{ uppercase(item) }}</template>
      <template v-slot:selection="{ item }">{{ uppercase(item) }}</template>
    </v-select>
  </div>
</template>

<script>
import uppercase from './../filters/uppercase';
export default {
  name: 'language-switcher',
  methods: {
    uppercase
  },
  computed: {
    language: {
      set(value) {
        this.$store.dispatch('setLanguage', value);
        //this.$router.replace({ path: this.$i18n.t(this.$route.name) });
      },
      get() {
        return this.$store.getters.language;
      }
    }
  }
};
</script>
